import React from 'react';
import { Box } from '@mui/material';
import dayjs from 'dayjs';
import { HELPER_TEXT_RETURN } from '../lang';
import { type ApplicationRemarkType } from '../../../../Nomination/graphql';
import { TextField, UserRole } from '../../../../../components';
import { theme } from '../../../../../Theme';

type ReturnRemarksProps = {
  returnRemarks: ApplicationRemarkType[];
};

export const ReturnRemarks: React.FunctionComponent<
  ReturnRemarksProps
> = props => {
  const { returnRemarks } = props;
  const displayRmk = returnRemarks.filter(rmk =>
    rmk.toRole.includes(UserRole.APPLICANT),
  );
  return (
    <>
      <Box marginX={4}>
        <h2 className="text-[#951D1D] font-semibold mb-4">
          {HELPER_TEXT_RETURN}
        </h2>
      </Box>
      <Box padding={2} marginX={4} bgcolor={theme.palette.grey['200']}>
        {displayRmk.map((rmk, index) => {
          const { remark, createdAt } = rmk;
          const updateTime =
            ' (at ' + dayjs(createdAt).format('DD/MM/YYYY') + ')';
          return (
            <TextField
              className="!mt-2"
              key={index}
              value={remark + updateTime}
              minRows={8}
              disabled
              multiline
              fullWidth
            />
          );
        })}
      </Box>
    </>
  );
};
